import React from "react";

export default function PlaybackPreview() {
  return (
    <div className="flex h-full flex-col justify-between">
      <div className="flex h-[62px] items-center justify-center rounded-[18px] bg-gradient-to-r from-blue-500 via-indigo-400 to-sky-300 text-sm font-semibold text-white shadow-inner">
        Video Playback
      </div>

      <div className="mt-3">
        <div className="mb-2 flex justify-between text-[10px] text-gray-500 dark:text-gray-400">
          <span>16:30</span>
          <span>16:40</span>
          <span>16:50</span>
          <span>17:00</span>
        </div>

        <div className="relative h-10 overflow-hidden rounded-[16px] border border-slate-200 bg-white/80 dark:border-white/10 dark:bg-black/20">
          <div className="absolute left-[8%] top-3 h-3 w-[28%] rounded-md bg-blue-500" />
          <div className="absolute left-[42%] top-3 h-3 w-[18%] rounded-md bg-indigo-400" />
          <div className="absolute left-[66%] top-3 h-3 w-[12%] rounded-md bg-sky-400" />
          <div className="absolute bottom-0 top-0 left-[58%] w-[2px] bg-red-500" />
        </div>
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <div className="rounded-xl bg-white/80 px-3 py-2 text-[11px] font-semibold dark:bg-white/10">
          ⏮ 처음
        </div>

        <div className="rounded-xl bg-white/80 px-3 py-2 text-[11px] font-semibold dark:bg-white/10">
          ◀ 이전
        </div>

        <div className="rounded-xl bg-blue-600 px-3 py-2 text-[11px] font-semibold text-white">
          ▶ 재생
        </div>
      </div>
    </div>
  );
}